import { render } from "./PriceTemplateEditPage.vue?vue&type=template&id=e2b4c700"
import script from "./PriceTemplateEditPage.vue?vue&type=script&lang=js"
export * from "./PriceTemplateEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__